import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientStatsPanel = ({ stats }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    })?.format(amount);
  };

  const statCards = [
    {
      title: 'Total Clients',
      value: stats?.totalClients,
      icon: 'Users',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      title: 'Particuliers',
      value: stats?.individualClients,
      icon: 'User',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      title: 'Professionnels',
      value: stats?.professionalClients,
      icon: 'Building',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      title: 'Sous-traitants',
      value: stats?.subcontractorClients,
      icon: 'HardHat',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    }
  ];

  const businessMetrics = [
    {
      title: 'Chiffre d\'affaires total',
      value: formatCurrency(stats?.totalRevenue),
      icon: 'TrendingUp',
      color: 'text-emerald-600'
    },
    {
      title: 'Devis générés',
      value: stats?.totalQuotes,
      icon: 'FileText',
      color: 'text-blue-600'
    },
    {
      title: 'Projets actifs',
      value: stats?.activeProjects,
      icon: 'Clock',
      color: 'text-amber-600'
    },
    {
      title: 'Taux de conversion',
      value: `${stats?.conversionRate}%`,
      icon: 'Target',
      color: 'text-green-600'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Client Distribution */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center space-x-2">
          <Icon name="PieChart" size={20} />
          <span>Répartition des clients</span>
        </h3>
        <div className="grid grid-cols-2 gap-4">
          {statCards?.map((stat, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 rounded-lg bg-muted/50">
              <div className={`p-2 rounded-lg ${stat?.bgColor}`}>
                <Icon name={stat?.icon} size={20} className={stat?.color} />
              </div>
              <div>
                <div className="text-2xl font-bold text-text-primary">{stat?.value}</div>
                <div className="text-sm text-text-secondary">{stat?.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Business Metrics */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center space-x-2">
          <Icon name="BarChart3" size={20} />
          <span>Métriques business</span>
        </h3>
        <div className="space-y-4">
          {businessMetrics?.map((metric, index) => (
            <div key={index} className="flex items-center justify-between p-3 rounded-lg hover:bg-muted/50 transition-smooth">
              <div className="flex items-center space-x-3">
                <Icon name={metric?.icon} size={18} className={metric?.color} />
                <span className="text-sm font-medium text-text-primary">{metric?.title}</span>
              </div>
              <div className="text-lg font-semibold text-text-primary">{metric?.value}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Recent Activity */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center space-x-2">
          <Icon name="Activity" size={20} />
          <span>Activité récente</span>
        </h3>
        <div className="space-y-3">
          {stats?.recentActivity?.map((activity, index) => (
            <div key={index} className="flex items-start space-x-3 p-3 rounded-lg bg-muted/30">
              <div className="p-1.5 rounded-full bg-primary/10">
                <Icon name={activity?.icon} size={14} className="text-primary" />
              </div>
              <div className="flex-1">
                <div className="text-sm font-medium text-text-primary">{activity?.title}</div>
                <div className="text-xs text-text-secondary">{activity?.description}</div>
                <div className="text-xs text-text-secondary mt-1">{activity?.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientStatsPanel;